(ns machtfit.startpage.layout
  (:require [re-frame.core :as rf]))

(defn reset-ui [db]
  (-> db
      (assoc-in [:ui :appointments-product-id] nil)
      (assoc-in [:ui :home-card-animating?] false)))

(defn subdomain-logo []
  [:img {:src @(rf/subscribe [:get [:subdomain-info :logo]])
         :alt (str "Unternehmenslogo von " @(rf/subscribe [:get [:subdomain]]))
         :tab-index "0"}])
